import { Contact } from "./contact.model";
import { RestrictedAccountObjectApiFacade } from "../restricted-account-object/restricted-account-object.api-facade";
import { Observable } from "rxjs/Observable";
import { ApiRequestOptions } from "../../../core/services/api/request-options";

export class ContactApiFacade extends RestrictedAccountObjectApiFacade<Contact> {

    get(accountId: string, id: string, options?: ApiRequestOptions): Observable<Contact> {
        return this.GET(`/accounts/${accountId}/contacts/${id}`, options)
            .map(object => new Contact(object));
    }

    getAll(accountId: string, options?: ApiRequestOptions): Observable<Array<Contact>> {
        return this.CGET(`/accounts/${accountId}/contacts`, options)
            .map(list => list.map(object => new Contact(object)));
    }
}



// WEBPACK FOOTER //
// ./src/vas/business-objects/contact/contact.api-facade.ts